import TTObjectModelBase from '../_generated/modelBases/tt-object-model-base';

export default class TTObjectModel extends TTObjectModelBase {
  // For instructions on how to use Models visit:
  // https://glittrsoftware.visualstudio.com/glittr.core/_wiki/wikis/glittr.core.wiki/429/ServiceModels-DTOs
}
